export enum TransitionPriority {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    REVERT = 'REVERT',
    NONE = 'NONE',
}
